<template>
    <div class="signup-dialog" v-show="_visible">
        <div class="signup-dialog__mask"></div>
        <div class="signup-dialog__main" v-show="!showSuccess">
            <span class="signup-dialog__title">免费预约<span class="high-light">价值1对1在线</span>试听</span>
            <input class="signup-dialog__input" v-model.trim="enrollform.name" auto-complete="off" placeholder="请输入学生姓名" >
            <input class="signup-dialog__input" v-model.trim="enrollform.phoneNumber" auto-complete="off" placeholder="请输入您的手机号" >
            <div class="signup-dialog__row-3">
                <div class="signup-dialog__select-wrap">
                    <select class="signup-dialog__select" :class="{'signup-dialog__select--disabled':!enrollform.grade}" v-model="enrollform.grade">
                        <option value="" disabled selected style="display:none;">请选择年级</option>
                        <option v-for="item in gradeArray" :value="item.code" :key="item.code" :label="item.gradeName">{{ item.gradeName }}</option>
                    </select>
                </div>
                <div class="signup-dialog__select-wrap">
                    <select class="signup-dialog__select" :class="{'signup-dialog__select--disabled':!enrollform.subject}" v-model="enrollform.subject">
                        <option value="" disabled selected style="display:none;">请选择学科</option>
                        <option v-for="item in subjectArray" :value="item.code" :key="item.code" :label="item.subjectName">{{ item.subjectName }}</option>
                    </select>
                </div>
            </div>
            <span class="signup-dialog__submit" @click="handleSignUp('enrollform')">{{ loading?'提交中...':'名额有限，立即领取' }}</span>
            <span class="signup-dialog__hint" v-show="hint.show">* {{ hint.text }}</span>
            <div class="agreement">
                <img src="../../../assets/images/mobile/popup_gouxuan_default_mobile.png" alt="" class="agreement-pic" v-if="showIcon" @click="showIcon = false">
                <img src="../../../assets/images/mobile/popup_gouxuan_gray_mobile.png" alt="" class="agreement-pic" v-else @click="showIcon = true">
                <span class="agreement-text">同意<span style="color:#3d6eb8;" @click="userAgreement">《好分数辅导用户协议》、</span><span style="color:#3d6eb8" @click="privacyAgreement">《好分数辅导隐私政策》</span>和<span style="color:#3d6eb8" @click="childPrivaryPolicy">《儿童隐私政策》</span></span>
            </div>
        </div>
        <div class="success-view" v-show="showSuccess">
            <i class="success-view__icon"></i>
            <span class="success-view__title">提交成功</span>
            <span class="success-view__text">您已预约成功，24小时内会有课程顾问跟您联系</span>
            <span class="success-view__btn" @click="_visible=false;showSuccess=false">确定</span>
        </div>
        <i class="signup-dialog__close-btn" @click="_visible=false;showSuccess=false"></i>
        <div v-if="showToast" class="show-toast">
            <div class="show-toast-text">请勾选同意《好分数辅导用户协议》、《好分数辅导隐私政策》和《儿童隐私政策》</div>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        // 报名弹窗
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        _visible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('change', val);
            }
        }
    },
    data() {
        return {
            enrollform: {
                name: '',
                phoneNumber: '',
                subject: '',
                grade: ''
            },
            gradeArray: [
                { gradeName: '初一', code: 10 },
                { gradeName: '初二', code: 20 },
                { gradeName: '初三', code: 30 },
                { gradeName: '高一', code: 50 },
                { gradeName: '高二（文科）', code: 61 },
                { gradeName: '高二（理科）', code: 62 },
                { gradeName: '高三（文科）', code: 71 },
                { gradeName: '高三（理科）', code: 72 }
            ],
            subjectArray: [
                { subjectName: '语文', code: '21' },
                { subjectName: '数学', code: '20' },
                { subjectName: '英语', code: '3' },
                { subjectName: '物理', code: '6' },
                { subjectName: '化学', code: '5' },
                { subjectName: '生物', code: '27' }
            ],
            hint: {
                show: false,
                text: ''
            },
            loading: false,
            showSuccess: false,
            showIcon: true,
            showToast: false
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.flag = true;
            }
        }
    },
    methods: {
        // ...mapActions(['USER_POST_SIGNUP']),
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        handleSignUp(formName) {
            if (this.loading) return;
            if (!this.showIcon) {
                this.showToast = true;
                setTimeout(() => {
                    this.showToast = false;
                }, 3000);
                return;
            }
            let { name, phoneNumber, grade, subject } = this.enrollform;
            if (!name) {
                return this.showHint('请输入学生姓名');
            }
            if (!phoneNumber) {
                return this.showHint('请输入手机号码');
            } else if (!/^1[0-9]{10}$/.test(phoneNumber)) {
                return this.showHint('请输入正确的11位手机号码');
            }
            if (!grade) {
                return this.showHint('请选择年级');
            }
            if (!subject) {
                return this.showHint('请选择学科');
            }
            this.loading = true;
            this.$http.post('/v1/appointments', {
                flag: 'hfsfd-ow',
                name,
                phone: phoneNumber,
                grade,
                subject,
                pageFlag: '官网报名'
            })
                .then(resp => {
                    if (resp.code === 0) {
                        return {
                            success: true
                        };
                    } else if (resp.code === 1004 || resp.code === 3101) {
                        return {
                            hasSignUp: true
                        };
                    } else {
                        return Promise.reject({
                            code: resp.code,
                            msg: resp.msg
                        });
                    }
                })
                .then(data => {
                    if (data.success) {
                        this.enrollform = {
                            name: '',
                            phoneNumber: '',
                            subject: '',
                            grade: ''
                        };
                        this.showSuccess = true;
                    } else {
                        this.showHint('已经报过名');
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        showHint(text) {
            this.hint.text = text;
            this.hint.show = true;
            setTimeout(() => {
                this.hint.show = false;
            }, 3000);
        },
        // 跳转儿童协议
        childPrivaryPolicy() {
            window.location.href = `${feConfig.agreementUrl}/childPrivaryPolicy.html`;
        },
        // 跳转用户协议
        userAgreement() {
            window.location.href = `${feConfig.agreementUrl}/userAgreement.html`;
        },
        // 跳转隐私协议
        privacyAgreement() {
            window.location.href = `${feConfig.agreementUrl}/privaryPolicy.html`;
        }
    }
};
</script>

<style lang="scss" scoped>
.signup-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    z-index: 2000;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &__mask {
        position: absolute;
        height: 100%;
        width: 100%;
        background: rgba(0,0,0,.7);
    }
    &__main {
        padding: 0.4rem 0.18rem 0;
        position: relative;
        width: 6.5rem;
        // height: 5.92rem;
        border-radius: .2rem;
        background: #fff;
    }
    &__title {
        display: block;
        text-align: center;
        font-size: .4rem;
        color: #333333;
        margin-bottom: 0.3rem;
        font-weight: bold;
        .high-light {
            color: #f00;
        }
    }
    &__input {
        font-size: 0.26rem;
        display: block;
        height: 0.88rem;
        border: 1px solid #E6E6E6;
        border-radius: .1rem;
        width: 100%;
        text-indent: .2rem;
        outline: none;
        margin-bottom: .2rem;
        background: none;
        appearance: none;

        &::placeholder {
            color: #ccc;
        }
    }
    &__row-3 {
        display: flex;
        height: 0.88rem;
        margin-bottom: .4rem;
    }
    &__select-wrap {
        flex: 1;
        height: 100%;
        position: relative;
        margin-right: .1rem;

        &::after {
            content: ' ';
            display: block;
            width: 0.2rem;
            height: 0.1rem;
            border-top: .1rem solid #999;
            border-left: .1rem solid transparent;
            border-right: .1rem solid transparent;
            position: absolute;
            top: 0;
            bottom: 0;
            right: .2rem;
            margin: auto 0;
        }

        &:last-of-type {
            margin-right: 0;
        }
    }
    &__select {
        display: block;
        width: 100%;
        height: 100%;
        border: 1px solid #E6E6E6;
        border-radius: .1rem;
        text-indent: .2rem;
        background: none;
        outline: none;
        appearance: none;

        &--disabled {
            color: #ccc;
        }
    }
    &__submit {
        display: block;
        width: 100%;
        height: .78rem;
        background-image: linear-gradient(135deg, #FF5A00 0%, #FF2500 100%);
        box-shadow: 0 0.06rem 0.2rem 0 rgba(244,102,75,0.28);
        border-radius: .52rem;
        font-size: 0.3rem;
        line-height: 0.78rem;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: .1rem;
    }
    &__hint {
        display: block;
        color: #FF2E00;
        font-size: 0.24rem;
    }
    &__close-btn {
        display: block;
        position: relative;
        width: 0.6rem;
        height: 0.6rem;
        background: url('../../../assets/images/mobile/home_icon_gb.png') no-repeat center / cover;
        margin-top: 0.2rem;
    }
}
.success-view {
    padding: 0.95rem 0.75rem 0;
    position: relative;
    width: 6rem;
    height: 5.92rem;
    border-radius: .2rem;
    background: #fff;
    &__icon {
        display: block;
        width: 1.3rem;
        height: 1.3rem;
        margin: 0 auto .2rem;
        background: url('../../../assets/images/mobile/home_icon_cg.png') no-repeat center / cover;
    }
    &__title {
        font-size: .40rem;
        color: #333333;
        font-weight: bold;
        display: block;
        text-align: center;
        line-height: 0.56rem;
        margin-bottom: 0.2rem;
    }
    &__text {
        display: block;
        font-size: 0.28rem;
        color: #4D4D4D;
        line-height: 0.4rem;
        margin-bottom: .62rem;
    }
    &__btn {
        display: block;
        width: 100%;
        height: .78rem;
        background-image: linear-gradient(135deg, #FF5A00 0%, #FF2500 100%);
        box-shadow: 0 0.06rem 0.2rem 0 rgba(244,102,75,0.28);
        border-radius: .52rem;
        font-size: 0.3rem;
        line-height: 0.78rem;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: .1rem;
    }
}

.agreement {
    margin: .17rem 0 .51rem;
    display: flex;

    .agreement-pic {
        width: .28rem;
        height: .28rem;
        margin-right: .15rem;
    }

    .agreement-text {
        font-family: PingFangSC-Regular;
        font-size: .22rem;
        color: #333333;
        line-height: .36rem;
    }
}
.show-toast {
    position: absolute;
    width: 5.46rem;
    background: rgba(0,0,0,.7);
    border-radius: .06rem;
    margin: 0 auto;

    .show-toast-text {
        display: inline-block;
        font-family: PingFangSC-Regular;
        font-size: .26rem;
        color: #FFFFFF;
        text-align: center;
        line-height: .36rem;
        padding: .19rem .15rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/components/SignupDialog.vue